export const SELECT_THEME = 'app/ThemeProvider/SELECT_THEME';
